const lazy = path => () => import(`./${path}`);

// 发薪管理
export default [
  {
    path: "/bLogin",
    name: "bLogin",
    component: lazy("index"),
    meta: {
      title: "B 端登录",
      keepAlive: true // 缓存
    }
  }
];
